export default {
    // --------Title--------
    modifyContainer: 'แก้ไขข้อมูลภาชนะ',
    container: 'ภาชนะ',
    registeredContainerInformation: 'ข้อมูลภาชนะที่ลงทะเบียนแล้ว',
    detailInformationAboutTheItemsInvolved: 'ข้อมูลรายละเอียดเกี่ยวกับรายการที่เกี่ยวข้อง',
    uploadExcel: 'อัปโหลดไฟล์ Excel',
    selectThePackingDocumentToImport: 'เลือกเอกสารการบรรจุเพื่อทำการนำเข้า',
    provideInformationAboutContainer: 'ให้ข้อมูลเกี่ยวกับภาชนะ',
    availableProducts: 'สินค้าที่มีอยู่',
    availableItems: 'รายการที่มีอยู่',
    containerInformation: 'ข้อมูลภาชนะ',
    detailsInformationAboutContainer: 'ข้อมูลรายละเอียดเกี่ยวกับภาชนะ',
    searchSupplierNoOrSignedByOrMarking: `ค้นหาหมายเลขผู้จัดส่ง หรือผู้ลงนาม หรือสัญลักษณ์บรรจุภัณฑ์`,
    modifyLoadContainerDateTime: `แก้ไขวันและเวลาโหลดภาชนะ`,

    // --------Dialog & Drawer Title-------
    addContainerItems: 'เพิ่มรายการในภาชนะ',
    customerMarking: 'สัญลักษณ์ของลูกค้า',
    searchCustomerDetailsByMarking: 'ค้นหารายละเอียดลูกค้าจากสัญลักษณ์',
    searchCustomerByMarking: 'ค้นหาลูกค้าจากสัญลักษณ์',
    updateContainerInformation: 'อัปเดตข้อมูลภาชนะ',
    relatedWarehouseLocationToProcess: 'สถานที่คลังสินค้าที่เกี่ยวข้องกับกระบวนการ',
    fileName: 'ชื่อไฟล์ :',
    calculateTheSummaryOfTheContainerInformationPerformValidationBeforeImportIntoSystem: 'คำนวณสรุปข้อมูลภาชนะและตรวจสอบความถูกต้องก่อนนำเข้าระบบ',
    updateRemark: 'อัปเดตหมายเหตุ',
    proofOfDelivery: 'หลักฐานการส่งมอบ',
    proofOfDeliveryDetails: 'รายละเอียดหลักฐานการส่งมอบ',

    mixedLCL: "การขนส่งแบบ LCL รวมตู้",
    fullFCL: "การขนส่งแบบ FCL เต็มตู้",
    shipLCL: "การขนส่งแบบ LCL โดยสายเรือ",

    // ----------MUI--------
    modify: 'แก้ไข',
    importPackingExcel: 'นำเข้าไฟล์ Excel การบรรจุ',
    downloadPackingExcelFull: 'ดาวน์โหลดไฟล์ Excel การบรรจุ (ฉบับเต็ม)',
    downloadPackingExcelSimple: 'ดาวน์โหลดไฟล์ Excel การบรรจุ (ฉบับย่อ)',
    repositoryNo: 'ภาชนะที่ไม่มี',
    repositoryAltNo: 'ตัวเลือกทางเลือกหมายเลข 2',
    containerNo: 'ภาชนะที่ไม่มี',
    secondaryNo: 'ตัวเลือกทางเลือกหมายเลข 2',
    sealNo: 'ไม่มีการปิดผนึก',
    loadDate: 'วันโหลด',
    customAgent: 'ตัวแทนศุลกากร',

    locationName: 'ชื่อสถานที่',
    destinationLocation: 'สถานที่ปลายทาง',
    action: 'การดำเนินการ',
    containerSize: 'ขนาดภาชนะ',
    containerType: 'ประเภทภาชนะ',
    repositoryMarking: 'ภาชนะที่ทำเครื่องหมาย',
    initialDate: 'วันที่เริ่มต้น',
    supervisor: 'ผู้ควบคุมงาน',
    shipper: 'ผู้จัดส่งสินค้า',
    totalPackQty: 'จำนวนบรรจุทั้งหมด',
    totalValues: 'มูลค่ารวม',
    totalWeight: 'น้ำหนักรวม',
    totalCbm: 'ปริมาตรรวม (CBM)',

    splitProductItems: 'แยกรายการสินค้า',
    status: 'สถานะ',
    courierNo: 'หมายเลขขนส่ง',
    purchaseNo: 'หมายเลขใบสั่งซื้อ',
    packQty: 'จำนวนบรรจุ',
    values: 'มูลค่า',
    weight: 'น้ำหนัก',
    qty: 'จำนวน',
    signedBy: 'ลงนามโดย',
    loadDateTime: 'วันที่และเวลาโหลด',
    createdatetime: 'วันที่และเวลาที่สร้าง',
    no: 'ลำดับที่',
    dimension: 'ขนาด (LxHxW)',
    used: 'ใช้งานแล้ว',
    loadQty: 'จำนวนโหลด',
    createDateTime: 'วันที่และเวลาที่สร้าง',
    uploadFile: 'อัปโหลดไฟล์',
    downloadTemplate: 'ดาวน์โหลดแม่แบบ',
    confirmImport: 'ยืนยันการนำเข้า',
    close: 'ปิด',
    noProofDetailAtTheMoment: 'ยังไม่มีรายละเอียดหลักฐานการจัดส่งในขณะนี้'

}